/**
 * supplierDetailHelpers.ts
 * 협력사 상세 정보 관련 유틸리티 함수 모음
 */

/**
 * 공제타입 코드를 한글 라벨로 변환
 * @param deductType 공제타입 코드 (RENT, LEASE, ETC)
 * @returns 한글 라벨
 */
export const getDeductTypeLabel = (deductType: string): string => {
    const typeMap: { [key: string]: string } = {
        'RENT': '렌트',
        'LEASE': '리스',
        'ETC': '기타'
    };
    return typeMap[deductType] || deductType;
};

/**
 * 사업자등록번호 포맷팅 (하이픈 제거)
 * @param businessNumber 사업자등록번호
 * @returns 하이픈이 제거된 사업자등록번호
 */
export const cleanBusinessNumber = (businessNumber: string): string => {
    return businessNumber.replace(/-/g, '');
};

/**
 * 사업자 정보 유효성 검사
 * @param companyName 법인명
 * @param businessNumber 사업자등록번호
 * @param representative 대표자명
 * @returns 유효성 검사 결과
 */
export const validateBusinessInfo = (
    companyName: string,
    businessNumber: string,
    representative: string
): boolean => {
    return !!(companyName && businessNumber && representative);
};

/**
 * 전화번호 포맷팅 제거 (하이픈 제거)
 */
export const cleanPhoneNumber = (phoneNumber: string): string => {
    return phoneNumber.replace(/-/g, '');
};

/**
 * 은행 목록 상수
 */
export const BANK_OPTIONS = [
    '농협은행',
    '국민은행',
    '신한은행',
    '우리은행',
    '하나은행'
] as const;
